import React from 'react';
import { GetStaticProps } from 'next';
import fetchUtil from '../../utils/fetchUtil';
import ErrorComponent from '../../components/ErrorComponent';
import FranchiseeComponent from '../../components/StudyAbroad/FranchiseeComponent';
import { CACHE_REVALIDATE_24H } from '../../utils/constants';

const StudyAbroadRecruiter: React.FC = (props: any) => {
    if (!props.pageData) {
        return <ErrorComponent />
    }

    return (
        <FranchiseeComponent eventData={props.pageData} />
    )
}

export const getStaticProps: GetStaticProps = async () => {
    const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/pst-landing-page?`, 'GET', {}, '', false)
    return {
        props: {
            pageData
        },
        revalidate: CACHE_REVALIDATE_24H,
    };
}

export default StudyAbroadRecruiter;
